// src/components/SiteHeader.jsx
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isLoggedIn, logout } from "../lib/auth";

export default function SiteHeader({ showAdmin = false }) {
  const loc = useLocation();
  const navigate = useNavigate();
  const loggedIn = isLoggedIn();

  const NavLink = ({ to, children }) => (
    <Link
      to={to}
      style={{
        padding: "8px 12px",
        borderRadius: 8,
        textDecoration: "none",
        color: loc.pathname === to ? "#0f766e" : "#0f172a",
        fontWeight: loc.pathname === to ? 700 : 500,
        fontSize: 14,
      }}
    >
      {children}
    </Link>
  );

  const handleLogout = (e) => {
    e.preventDefault();
    logout();            // clears token / session

    // if your logout() does NOT redirect automatically,
    // uncomment the next line to send user to login:
    // navigate("/admin/login");
  };

  return (
    <header style={{ borderBottom: "1px solid #e5e7eb", background: "#fff" }}>
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            textDecoration: "none",
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              background: "#0f766e",
            }}
          />
          <span
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: "#0f172a",
            }}
          >
            YogaPay
          </span>
        </Link>

        <nav style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/register">Register</NavLink>

          {showAdmin && (
            <>
              {!loggedIn && <NavLink to="/admin/login">Admin Login</NavLink>}

              {loggedIn && <NavLink to="/dashboard">Dashboard</NavLink>}

              {loggedIn && (
                <button
                  onClick={handleLogout}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    color:
                      loc.pathname === "/admin/logout"
                        ? "#0f766e"
                        : "#0f172a",
                    fontWeight:
                      loc.pathname === "/admin/logout" ? 700 : 500,
                    fontSize: 14,
                  }}
                >
                  Logout
                </button>
              )}
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
